export const SwitchPrereq = (updateElements, element) => {
    if (element.id === "1") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[31].style = {
        ...updateElements[31].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    } else if (element.id === "2") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[1].style = {
        ...updateElements[1].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    } else if (element.id === "3") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "4") {
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "5a" || element.id === "5" || element.id === "6") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[5].style = {
        ...updateElements[5].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[6].style = {
        ...updateElements[6].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    } else if (element.id === "7") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[5].style = {
        ...updateElements[5].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[6].style = {
        ...updateElements[6].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[7].style = {
        ...updateElements[7].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    } else if (element.id === "8") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[8].style = {
        ...updateElements[8].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    } else if (element.id === "9") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[9].style = {
        ...updateElements[9].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "10") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[10].style = {
        ...updateElements[10].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (
      element.id === "11" ||
      element.id === "11a" ||
      element.id === "12"
    ) {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[10].style = {
        ...updateElements[10].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[12].style = {
        ...updateElements[12].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[13].style = {
        ...updateElements[13].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "18") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[10].style = {
        ...updateElements[10].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[12].style = {
        ...updateElements[12].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[13].style = {
        ...updateElements[13].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[19].style = {
        ...updateElements[19].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "13") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[5].style = {
        ...updateElements[5].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[6].style = {
        ...updateElements[6].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[7].style = {
        ...updateElements[7].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[14].style = {
        ...updateElements[14].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    } else if (element.id === "14") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[5].style = {
        ...updateElements[5].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[6].style = {
        ...updateElements[6].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[7].style = {
        ...updateElements[7].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[15].style = {
        ...updateElements[15].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    } else if (element.id === "15") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[8].style = {
        ...updateElements[8].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[9].style = {
        ...updateElements[9].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[16].style = {
        ...updateElements[16].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[5].style = {
        ...updateElements[5].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[6].style = {
        ...updateElements[6].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[7].style = {
        ...updateElements[7].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    } else if (element.id === "16") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[9].style = {
        ...updateElements[9].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[17].style = {
        ...updateElements[17].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "17") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[9].style = {
        ...updateElements[9].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[18].style = {
        ...updateElements[18].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (
      element.id === "19" ||
      element.id === "19a" ||
      element.id === "20"
    ) {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[9].style = {
        ...updateElements[9].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[10].style = {
        ...updateElements[10].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[21].style = {
        ...updateElements[21].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[22].style = {
        ...updateElements[22].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "21") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[9].style = {
        ...updateElements[9].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[23].style = {
        ...updateElements[23].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "22") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[9].style = {
        ...updateElements[9].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[17].style = {
        ...updateElements[17].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[24].style = {
        ...updateElements[24].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    } else if (element.id === "23") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[2].style = {
        ...updateElements[2].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[9].style = {
        ...updateElements[9].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[17].style = {
        ...updateElements[17].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[18].style = {
        ...updateElements[18].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[25].style = {
        ...updateElements[25].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    }
    if (element.id === "30") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
      updateElements[31].style = {
        ...updateElements[31].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
    }
    else if (element.id === "32") {
      updateElements[0].style = {
        ...updateElements[0].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
      updateElements[3].style = {
        ...updateElements[3].style,
        backgroundColor: "#dc143c",
        color: "white",
      };
 
      updateElements[32].style = {
        ...updateElements[32].style,
        backgroundColor: "#007FFF",
        color: "white",
      };
    }
  };
